import { render, staticRenderFns } from "./DeviceNotifyList_v3.vue?vue&type=template&id=67d5b88d&scoped=true&"
import script from "./DeviceNotifyList_v3.vue?vue&type=script&lang=js&"
export * from "./DeviceNotifyList_v3.vue?vue&type=script&lang=js&"
import style0 from "./DeviceNotifyList_v3.vue?vue&type=style&index=0&id=67d5b88d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5b88d",
  null
  
)

export default component.exports